export const LOCAL_ICE_SERVERS = [{ urls: 'stun:stun.l.google.com:19302' }];
export function createLivePeerConnection() {
    return new RTCPeerConnection({ iceServers: LOCAL_ICE_SERVERS });
}
export function closePeerConnection(peer) {
    if (!peer) {
        return;
    }
    peer.onicecandidate = null;
    peer.ontrack = null;
    peer.onconnectionstatechange = null;
    peer.close();
}
export function toRtcIceCandidateInit(candidate) {
    return {
        candidate: candidate.candidate ?? undefined,
        sdpMid: candidate.sdpMid ?? undefined,
        sdpMLineIndex: candidate.sdpMLineIndex ?? undefined,
        usernameFragment: candidate.usernameFragment ?? undefined,
    };
}
//# sourceMappingURL=peer.js.map